/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EmailSignatureResponseDraftTemplateKey = typeof EmailSignatureResponseDraftTemplateKey[keyof typeof EmailSignatureResponseDraftTemplateKey] | null;


export const EmailSignatureResponseDraftTemplateKey = {
  sidebar: 'sidebar',
  stacked: 'stacked',
  banner: 'banner',
} as const;
